import { flightRecorder, type Summary, type Tick } from "./FlightRecorder";
import { formatReport } from "./formatReport";

/** The `window.__sbDebug` surface: what an agent driving a browser, or a person in DevTools, calls. */
export type DebugBridge = {
  /** Resets, waits `ms`, and resolves the summary of exactly that window. */
  record(ms: number): Promise<Summary>;
  /** Aggregates the last `windowMs` (default 60s). */
  summary(windowMs?: number): Summary;
  /** The summary as pasteable Markdown. */
  report(windowMs?: number): string;
  /** The most recent ticks, newest first. */
  ticks(limit?: number): Tick[];
  reset(): void;
};

declare global {
  interface Window {
    __sbDebug?: DebugBridge;
  }
}

/** Installs `window.__sbDebug`; debug mode only. */
export function installDebugBridge(): void {
  window.__sbDebug = {
    record: (ms) => flightRecorder.record(ms),
    summary: (windowMs) => flightRecorder.summary(windowMs),
    report: (windowMs) => formatReport(flightRecorder.summary(windowMs)),
    ticks: (limit) => flightRecorder.recentTicks(limit),
    reset: () => flightRecorder.reset(),
  };
}
